import {
  PlatePage_CulturePlate,
  PlatePage_ObservationHistory,
} from '~/api/backend/pages/platePageAPI'
import Tabs from '~/components/Tabs'
import ObservationMetadataSidebar from '~/pages/plate/PlateObservationMetadataSidebar'
import PlateAbsorbanceGraphSideBar from './PlateAbsorbanceGraphSideBar'

export interface PlateAbsorbanceTabbedSidebarProps {
  plate: PlatePage_CulturePlate
  highlightedWell?: string
  observation?: PlatePage_ObservationHistory
}

export default function PlateAbsorbanceTabbedSidebar({
  plate,
  highlightedWell,
  observation,
}: PlateAbsorbanceTabbedSidebarProps) {
  const tabs = [
    {
      key: 'graph',
      title: 'Graph',
      panel: (
        <PlateAbsorbanceGraphSideBar plate={plate} highlightedWell={highlightedWell} />
      ),
    },
    {
      key: 'metadata',
      title: 'Metadata',
      panel: (
        <div className='space-y-4'>
          {observation && (
            <ObservationMetadataSidebar plate={plate} observation={observation} />
          )}
        </div>
      ),
    },
  ]

  return (
    <div>
      <Tabs tabs={tabs} initialTab='graph' />
    </div>
  )
}
